import { t } from '@hefe/i18n';
import { ResponseBasketballGetGameInfo } from '@hefe/models';
import { EventReportsSlice } from '@hefe/store';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../store/store';
import CustomForm from '../../../../core/components/form/custom-form';

export const GENERATE_EVENT_REPORT_WIZARD_PREGAME_FORM_ID =
  'generate-event-report-wizard-pregame-form';

interface GenerateEventReportWizardPregameFormComponentProps {
  data: ResponseBasketballGetGameInfo;
}

export default function GenerateEventReportWizardPregameFormComponent(
  props: GenerateEventReportWizardPregameFormComponentProps
) {
  const { data } = props;

  const dispatch = useAppDispatch();
  const wizard = useSelector(EventReportsSlice.generateWizardSelector);

  const onSubmit = (values: any, resetFields?: () => void) => {
    // store values in redux and go to next step
    dispatch(
      EventReportsSlice.actions.setPregameData({
        additional_info: values.additional_info,
      })
    );
  };

  return (
    <CustomForm
      fields={[
        {
          label: t(
            'game_reports.generate.wizard.steps.pregame.additional_info'
          ),
          name: 'pregame_header',
          type: 'heading',
          rules: [],
        },
        {
          type: 'textarea',
          name: 'additional_info',
          label: '',
          initalValue: wizard?.data?.additional_info,
          additionalProps: {
            rows: 5,
          },
          rules: [
            {
              max: 250,
              message: t('form_errors.max_length', { length: 200 }),
            },
          ],
        },
      ]}
      onSubmit={onSubmit}
      formId={GENERATE_EVENT_REPORT_WIZARD_PREGAME_FORM_ID}
    />
  );
}
